var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LandingPageBody',_vm._b({},'LandingPageBody',_vm.landingPageProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }